import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Transaction {
  loading: boolean;
  error: string | null;
  topupAmount: number;
  withdrawAmount: number;
}

const initialState: Transaction = {
  loading: false,
  error: null,
  topupAmount: 0,
  withdrawAmount: 0,
};

const transactionSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {
    setTopupAmount: (state, action: PayloadAction<any>) => {
      state.topupAmount = action.payload;
    },
    setWithdrawAmount: (state, action: PayloadAction<any>) => {
      state.withdrawAmount = action.payload;
    },
  },
});

// Export the actions, if there are any
export const { setTopupAmount, setWithdrawAmount } = transactionSlice.actions;

// Export the reducer
export default transactionSlice.reducer;
